// highlight-overview.js — upload to: assets/highlight-overview.js

if (!customElements.get('highlight-overview')) {
  class HighlightOverview extends HTMLElement {
    constructor() {
      super();
      // Bind context to prevent 'this' losses in event listeners
      this.measure = this.measure.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      // Find elements scoped specifically to THIS section instance
      this.sticky = this.querySelector('.hl-sticky');
      this.track = this.querySelector('.hl-track');
      this.progressWrap = this.querySelector('.hl-progress-wrap');
      this.progressBar = this.querySelector('.hl-progress-bar');

      if (!this.sticky || !this.track) return;

      this.MOBILE_BP = 767;
      this.SCROLL_MULTIPLIER = 1.0;
      this.totalScrollWidth = 0;
      this.outerHeight = 0;
      this.resizeTimer = null;

      this.initTilt();

      // Ensure measurement happens after paint
      if (document.readyState === 'complete') {
        this.measure();
      } else {
        window.addEventListener('load', this.measure);
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);

      // Refresh dimensions inside Shopify's Theme Editor
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (e) => {
          if (e.target.contains(this)) this.measure();
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.measure);
    }

    measure() {
      const isMobile = window.innerWidth <= this.MOBILE_BP;

      if (isMobile) {
        this.style.height = '';
        this.track.style.transform = '';
        return;
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const viewW = window.innerWidth;
          this.totalScrollWidth = Math.max(0, this.track.scrollWidth - viewW);
          this.outerHeight = window.innerHeight + this.totalScrollWidth * this.SCROLL_MULTIPLIER;
          this.style.height = `${this.outerHeight}px`;
          this.onScroll();
        });
      });
    }

    onScroll() {
      if (window.innerWidth <= this.MOBILE_BP || !this.outerHeight) return;

      const rect = this.getBoundingClientRect();
      const scrolled = -rect.top;
      const total = this.outerHeight - window.innerHeight;

      if (total <= 0) return;

      const clamped = Math.max(0, Math.min(scrolled, total));
      const pct = clamped / total;
      const moveX = -(pct * this.totalScrollWidth);

      this.track.style.transform = `translateX(${moveX.toFixed(2)}px)`;

      if (this.progressBar) {
        const percentRaw = (pct * 100).toFixed(2);
        this.progressBar.style.width = `${percentRaw}%`;
        this.progressWrap.setAttribute('aria-valuenow', percentRaw);
      }
    }

    initTilt() {
      // Validate hover device capabilities
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      const MAX_TILT = 5;

      this.track.querySelectorAll('.hl-card').forEach((card) => {
        const wrap = card.querySelector('.hl-card-image-wrap');
        if (!wrap) return;

        card.addEventListener('mouseenter', () => {
          wrap.style.transition = 'transform 0.1s ease, box-shadow 0.32s ease';
        });

        card.addEventListener('mousemove', (e) => {
          const r = wrap.getBoundingClientRect();
          const dx = (e.clientX - (r.left + r.width / 2)) / (r.width / 2);
          const dy = (e.clientY - (r.top + r.height / 2)) / (r.height / 2);
          
          wrap.style.transform = `translateY(-10px) scale(1.025) perspective(800px) rotateX(${(-dy * MAX_TILT).toFixed(2)}deg) rotateY(${(dx * MAX_TILT).toFixed(2)}deg)`;
        });

        card.addEventListener('mouseleave', () => {
          wrap.style.transition = 'transform 0.5s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.32s ease';
          wrap.style.transform = 'none';
        });
      });
    }

    onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(this.measure, 150);
    }
  }

  customElements.define('highlight-overview', HighlightOverview);
}
